<span class="po-pill" *ngIf="view as v" [ngClass]="'is-' + v.tone" [class.is-dashed]="v.dashed" data-test="preoffer-pill">
  <i class="fa-solid fa-file-signature" aria-hidden="true"></i>
  <span class="po-pill__label">Preoferta</span>
  <span class="po-pill__value">{{ v.label }}</span>
</span>
